import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../Utils/toastContext';
import UserQuestionnaire from './user-questionnarie';
const SurveyQuestion = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const [eddResponse, setEddResponse] = useState(null);
  const [overallRisk, setOverallRisk] = useState(null);

  const [riskResponse, setRiskResponse] = useState(null);

  const [eddId, setEddId] = useState(null);
  const username = useSelector((state) => state.user.username);
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [isConfirmWithdraw, setIsConfirmWithdraw] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const mapQuestions = (questions = []) => {
    const typeMap = {
      text: 1,
      radio: 2,
      select: 3,
      checkbox: 5,
      checkbox_with_percent: 4,
      multi_select: 6,
      file: 8,
      countries_with_percent: 9,
      country_select: 10,
    };

    return questions.map((q) => ({
      id: q.id,
      question: q.question_text,
      required: q.required,
      type: {
        value: typeMap[q.type.value] || 1,
      },
      options: (q.options || []).map((opt) => ({
        id: opt.id,
        label: opt.value,
        value: opt.value,
      })),
      answer: q.answer,
    }));
  };
  // const pendingQuestions = mapQuestions(
  //   eddResponse?.pending?.[0]?.questions || [],
  // );
  const completedQuestions = mapQuestions(
    (eddResponse || []).flatMap((item) => item?.questions || []),
  );

  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };

  const getEddResponses = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/agency/surveys/history`);
      if (response.status == 200) {
        setEddResponse(response.data);
        setOverallRisk(response.data[0].overall_risk_status);
      }
    } catch (err) {
      setEddResponse({});
      showToast(err.message, 'error');
    }
  };
  const getRiskResponse = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/agency/surveys/risk-assessment/current`,
      );
      if (response.status == 200) {
        setRiskResponse(response.data);
      }
    } catch (err) {
      setRiskResponse({});
      showToast(err.message, 'error');
    }
  };
  useEffect(() => {
    getEddResponses();
    getRiskResponse();
  }, []);

  return (
    <div className="p-4 flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[100vw]">
      <div className="flex-grow overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="bg-white border rounded-md p-4 mt-4">
            {completedQuestions.length > 0 && (
              <div className="w-full p-4">
                <UserQuestionnaire
                  apidata={completedQuestions}
                  rawResponses={eddResponse}
                  customerName={username}
                  isPending={false}
                  eddId={eddId}
                  afterSubmit={getEddResponses}
                  riskApiResponse={riskResponse}
                  heading={'Risk Assessment'}
                  overallRisk={overallRisk}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveyQuestion;
